import React from 'react';
import { X, HelpCircle } from 'react-feather';

interface HelpModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

export const HelpModal: React.FC<HelpModalProps> = ({ isOpen, onClose, title, children }) => {
  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300 ease-in-out"
          onClick={onClose}
        />
      )}
      
      {/* Modal */}
      <div className={`fixed right-0 top-0 h-full w-[600px] bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
        isOpen ? 'translate-x-0' : 'translate-x-full'
      }`}>
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-eddy-light-gray bg-eddy-primary text-white">
          <div className="flex items-center gap-2">
            <HelpCircle size={20} />
            <h2 className="text-lg font-semibold">{title}</h2>
          </div>
          <button
            onClick={onClose}
            className="p-1 hover:bg-white/20 rounded-full transition-colors"
            aria-label="Close help"
          >
            <X size={18} />
          </button>
        </div>
        
        {/* Content */}
        <div className="h-full overflow-y-auto pb-16">
          <div className="p-6">
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

interface HelpButtonProps {
  onClick: () => void;
  className?: string;
}

export const HelpButton: React.FC<HelpButtonProps> = ({ onClick, className = '' }) => {
  return (
    <button
      onClick={onClick}
      className={`p-2 text-eddy-blue hover:text-eddy-primary hover:bg-eddy-light-gray rounded-full transition-colors ${className}`}
      title="Show help documentation"
      aria-label="Show help"
    >
      <HelpCircle size={18} />
    </button>
  );
};

export default HelpModal;